import { render } from "./evaluation.vue?vue&type=template&id=08de57e0&scoped=true"
import script from "./evaluation.vue?vue&type=script&lang=js"
export * from "./evaluation.vue?vue&type=script&lang=js"

import "./evaluation.vue?vue&type=style&index=0&id=08de57e0&scoped=true&lang=css"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08de57e0"]])

export default __exports__